(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcscan
   * @description
   *
   */
  angular
    .module('vcdms.vcscan', [
      'ui.router',
      'pdf',
      'ngTagsInput',
      'ui.bootstrap.typeahead'
    ]);
}());
